import React, { useState, useEffect ,useRef} from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";
import { useLocation } from "react-router-dom";
function ProactiveMonitoringDropDownOption(props) {
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => {
    const pathMap = [
        { path: "/proactive-monitoring", index: 0 },
        { path: "/pm-dashboard", index: 1 },
        { path: "/proactive-ticket", index: 2 },
    ];
    const matched = pathMap.find(p => 
        p.path === "/proactive-ticket" 
            ? location.pathname === p.path || location.pathname.startsWith(p.path + "/")
            : location.pathname.startsWith(p.path)
    );
    setSelectedItem(matched ? matched.index : null);
}, [location.pathname]);
  return (
    <div className={props.class}>
      <UncontrolledButtonDropdown>
        <DropdownToggle caret color="link" className={`p-0 ${selectedItem !== null ? 'proactive-active-dropdown' : ''}`}>
        <div style={{ display: "inline-block" }}>
        {selectedItem !== null && props.buttons[selectedItem] 
    ? props.buttons[selectedItem].name 
    : "Proactive"}</div>
          {/* <div style={{ display: "inline-block" }}>
    {selectedItem !== null ? props.buttons[selectedItem].yes.name : "Proactive"}
</div> */}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-right">
        {props.buttons.map((button, i) => (
        <DropdownItem
          key={i}
          active={selectedItem === i}
          onClick={() => {
            setSelectedItem(i);
            button.action();
          }}
        >
          {button.name}
        </DropdownItem>
      ))}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
}

export default ProactiveMonitoringDropDownOption;
